import { required, maxLength, email } from 'vuelidate/lib/validators';

export default {
    accountId: {
        required,
    },
};
